import styled from 'styled-components';
import { SPACING } from '@optimus-web/local-tokens';

export const MarginBase = styled.div`
    width: 100%;
`;
/** @deprecated use STACK for spacings between components instead */
export const MicroMargin = styled(MarginBase)`
    height: ${SPACING[50]}px;
`;
/** @deprecated use STACK for spacings between components instead */
export const SmallMargin = styled(MarginBase)`
    height: ${SPACING[100]}px;
`;
/** @deprecated use STACK for spacings between components instead */
export const MediumMargin = styled(MarginBase)`
    height: ${SPACING[200]}px;
`;
/** @deprecated use STACK for spacings between components instead */
export const LargeMargin = styled(MarginBase)`
    height: ${SPACING[300]}px;
`;
/** @deprecated use STACK for spacings between components instead */
export const ExtraLargeMargin = styled(MarginBase)`
    height: ${SPACING[400]}px;
`;
